export default "__VITE_ASSET__BBKWWZDC__"